import ContentBlockDescription from '@/components/custom/ContentBlock/ContentBlockDescription/index.vue';

export default {
  name: 'ContentBlockTitleDescription',
  components: { ContentBlockDescription },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    positionCenter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {}
};
